import type { QuickLink } from '@/types';
import styles from './QuickLinks.module.css';
import imgPharmacy  from '@/assets/images/dol-pharmacy-locator.png';
import imgDME       from '@/assets/images/dol-dme.png';
import imgHelp      from '@/assets/images/dol-help.png';

const STATIC_ICON: Record<string, string> = {
  PharmacyLocator:  imgPharmacy,
  DMEProviderLocator: imgDME,
  HelpSupport: imgHelp,
};

interface QuickLinksProps {
  quickLinks: QuickLink[];
  activeTab: string | null;
  onTabChange: (tabId: string) => void;
}

export function QuickLinks({ quickLinks, activeTab, onTabChange }: QuickLinksProps) {
  return (
    <section className={styles.section} aria-label="Quick Links">
      <div className={styles.cardRow}>
        {quickLinks.map((link) => {
          const isActive = activeTab === link.tabId;
          // Use DB-supplied icon if present; fall back to static map
          const iconSrc       = link.iconSrc       ?? STATIC_ICON[link.tabId]       ?? '';
          const icon = iconSrc;
          return (
            <button
              key={link.componentId}
              type="button"
              className={`${styles.card} ${isActive ? styles.cardActive : ''}`}
              aria-pressed={isActive}
              onClick={() => onTabChange(link.tabId)}
            >
              <div className={styles.iconWrap}>
                {icon && <img src={icon} alt="" className={styles.icon} aria-hidden="true" />}
              </div>
              <span className={styles.label}>{link.label}</span>
              {link.description && <span className={styles.desc}>{link.description}</span>}
            </button>
          );
        })}
      </div>
    </section>
  );
}
